import { render, staticRenderFns } from "./BarChartHorizontalDashboard.vue?vue&type=template&id=ec8ef29a"
import script from "./BarChartHorizontalDashboard.vue?vue&type=script&lang=js"
export * from "./BarChartHorizontalDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports